/**
 * Best-effort parsing of a single-line or comma-separated address for company create.
 * Falls back to storing the full string in streetName when structured parts cannot be inferred.
 */
export function parseFreeformAddress(address: string) {
  const empty = {
    streetNumber: '',
    unitNumber: '',
    streetName: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'Canada',
  }

  const trimmed = (address || '').trim()
  if (!trimmed) {
    return empty
  }

  const parts = trimmed
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)
  if (parts.length >= 2) {
    const first = parts[0]
    const lead = first.match(/^(\d+)\s+(.+)$/)
    const streetNumber = lead ? lead[1] : ''
    const streetName = lead ? lead[2] : first
    const lastPart = parts[parts.length - 1]
    const postalMatch = lastPart.match(
      /([A-Z]\d[A-Z]\s?\d[A-Z]\d|\d{5}(-\d{4})?)\s*$/i
    )
    let zipCode = ''
    let remainder = lastPart
    if (postalMatch && postalMatch.index !== undefined) {
      zipCode = postalMatch[1].replace(/\s+/g, ' ').trim()
      remainder = lastPart.slice(0, postalMatch.index).trim()
    }
    const tailTokens = remainder.split(/\s+/).filter(Boolean)
    const state = tailTokens.length ? tailTokens[tailTokens.length - 1] : ''
    const cityTail = tailTokens.length > 1 ? tailTokens.slice(0, -1).join(' ') : ''
    const middle = parts.slice(1, -1).join(', ')
    const city = [middle, cityTail].filter(Boolean).join(', ')

    return {
      streetNumber,
      unitNumber: '',
      streetName,
      city,
      state,
      zipCode,
      country: 'Canada',
    }
  }

  const lead = trimmed.match(/^(\d+)\s+(.+)$/)
  if (lead) {
    return {
      streetNumber: lead[1],
      unitNumber: '',
      streetName: lead[2],
      city: '',
      state: '',
      zipCode: '',
      country: 'Canada',
    }
  }

  return {
    streetNumber: '',
    unitNumber: '',
    streetName: trimmed,
    city: '',
    state: '',
    zipCode: '',
    country: 'Canada',
  }
}
